import { store } from '../store'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'

export default (to, from, next) => {
  if (store.state.user.user) {
    if (!firebase.auth().currentUser.emailVerified) {
      next('/verifizieremail')
    } else {
      next()
    }
  } else {
    next('/anmelden?link=' + to.path)
  }
}



// WEBPACK FOOTER //
// ./src/router/auth-guard.js